import styled from "styled-components";

export const StyledPeriodFilterModal = styled.div`
  .period-filter-container {
    display: flex;
    flex-flow: column nowrap;
    gap: 10px;
    & > div {
      width: 100%;
      display: flex;
      gap: 6px;
    }
  }
`;
